<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CancelOrderDialog',
  props: {
    orderId: { type: Number },
    routeTo: { type: String }
  },
  data: () => ({
    dialog: false,
    loading: false
  }),
  computed: {
    ...mapGetters(['locale'])
  },
  methods: {
    deleteOrder: function () {
      let locale = this.locale
      this.loading = true
      this.$ordersService
        .deleteOrder(this.orderId)
        .then(() => {
          this.$store.commit('TRUNCATE_MERGED_COVERSHEETS')
          this.$router.push({
            name: this.routeTo,
            params: { locale: locale }
          })
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="500">
      <template #activator="{ on, attrs }">
        <v-btn
          id="upload-wizard-document-actions-cancel-order-button"
          color="secondary"
          class="text-center normal-texttransform pa-4"
          dark
          v-bind="attrs"
          :loading="loading"
          v-on="on">
          {{ $t('component.common.cancelOrderDialog.cancel.order') }}
        </v-btn>
      </template>
      <v-card>
        <DialogBaseColoredTitle color="primary">{{
            $t('component.common.cancelOrderDialog.cancel.order')
          }}</DialogBaseColoredTitle>
        <v-divider></v-divider>
        <DialogBaseText class="text-center primary--text">
          <v-row>
            <v-col> {{ $t('component.common.cancelOrderDialog.content') }} </v-col>
          </v-row>
        </DialogBaseText>
        <DialogBaseText class="text-center primary--text">
          <v-row>
            <v-col> {{ $t('component.common.cancelOrderDialog.sub.content') }} </v-col>
          </v-row>
        </DialogBaseText>
        <v-divider></v-divider>
        <DialogBaseActions>
          <v-row class="ma-0">
            <v-col>
              <v-btn
                color="secondary"
                class="white--text px-8"
                @click="dialog = false">
                <span>{{ $t('global.no') }}</span></v-btn>
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                class="white--text px-8"
                @click="deleteOrder()"
              ><span>{{ $t('global.yes') }}</span></v-btn>
            </v-col>
          </v-row>
        </DialogBaseActions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<style lang="scss" scoped>
.normal-texttransform {
  text-transform: none;
  letter-spacing: 0.1px;
}
</style>
